import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import Reveal, { EASE } from "@/components/Reveal";

const FAQS = [
  {
    q: "Fa male?",
    a: "Utilizzo tecniche mini-invasive e un'attenzione costante al tuo comfort: l'obiettivo è rendere il percorso il più sereno possibile.",
    id: 1,
  },
  {
    q: "Mi vergognerò? Non riesco proprio a parlarne…",
    a: "Lo dicono quasi tutti i miei pazienti all'inizio. Il mio lavoro comincia proprio da qui: colloqui sereni, nessun giudizio e un ambiente dove metterti al tuo agio.",
    id: 2,
  },
  {
    q: "Quanto dura il recupero?",
    a: "I tempi di recupero dipendono dal trattamento e solitamente sono molto rapidi. Ne parliamo insieme in base alla tua situazione.",
    id: 3,
  },
  {
    q: "Come funziona la prima visita?",
    a: "Prima di tutto parliamo: ascolto la tua storia senza fretta, poi valutiamo insieme il percorso migliore per te. Nessuna paura, nessun tabù.",
    id: 4,
  },
  {
    q: "Posso sentirti prima di prenotare?",
    a: "Certo: compila il modulo e scegli la videoconsulenza, oppure scrivi nelle note riservate. Ti ricontatto personalmente.",
    id: 5,
  },
];

export default function Faq() {
  const [open, setOpen] = useState(1);

  return (
    <section id="faq" className="relative py-28">
      <div className="max-w-4xl mx-auto px-6">
        <Reveal className="text-center">
          <p className="eyebrow">Le domande che ho sempre sentito</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl mt-4 tracking-tight">
            Le paure sono normali. <span className="italic text-gold">Le risposte pure.</span>
          </h2>
        </Reveal>

        <div className="mt-14 space-y-4">
          {FAQS.map((f, i) => (
            <Reveal key={f.id} delay={i * 0.05}>
              <div
                className={`rounded-2xl border transition-colors duration-300 ${
                  open === f.id ? "border-gold/35 bg-card" : "border-white/10 bg-card/50"
                }`}
              >
                <button
                  onClick={() => setOpen(open === f.id ? 0 : f.id)}
                  data-testid={`faq-accordion-item-${f.id}`}
                  className="w-full flex items-center justify-between gap-6 px-6 sm:px-8 py-5 text-left"
                >
                  <span className="font-display text-lg sm:text-xl text-ivory">{f.q}</span>
                  <motion.span
                    animate={{ rotate: open === f.id ? 45 : 0 }}
                    transition={{ duration: 0.3, ease: EASE }}
                    className={`shrink-0 ${open === f.id ? "text-gold" : "text-silver"}`}
                  >
                    <Plus size={20} />
                  </motion.span>
                </button>
                <AnimatePresence initial={false}>
                  {open === f.id && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.35, ease: EASE }}
                      className="overflow-hidden"
                    >
                      <p className="px-6 sm:px-8 pb-6 text-silver leading-relaxed">{f.a}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
